var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "inbox-content" } }, [
    _c("div", { staticClass: "content-header" }, [
      _c("h2", [
        _vm._v("Form Yanıtlanma Tarihi: " + _vm._s(_vm.formattedDate)),
      ]),
      _vm._v(" "),
      _vm.notReadBtn
        ? _c(
            "button",
            { staticClass: "button", on: { click: _vm.markAsRead } },
            [_vm._v("Okundu Olarak işaretle")]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content-body" },
      _vm._l(_vm.sortedAnswers, function (answer, index) {
        return _c("div", { key: index, staticClass: "info-item" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v("\n      " + _vm._s(_vm.getLabelText(answer)) + "\n    "),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "value" }, [
            answer.fieldLabelFile
              ? _c("span", [
                  _c(
                    "ul",
                    _vm._l(answer.files, function (url, index) {
                      return _c(
                        "li",
                        { key: index, staticClass: "image-list-item" },
                        [
                          _c("img", {
                            attrs: {
                              src: _vm.prependHttps(url),
                              alt: "Image " + (index + 1),
                            },
                            on: {
                              click: function ($event) {
                                _vm.openModal(_vm.prependHttps(url))
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                ])
              : _c("span", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.getAnswerValue(answer)) +
                      "\n      "
                  ),
                ]),
          ]),
        ])
      }),
      0
    ),
    _vm._v(" "),
    _vm.isModalVisible
      ? _c(
          "div",
          { staticClass: "modal-overlay", on: { click: _vm.closeModal } },
          [
            _c(
              "div",
              {
                staticClass: "modal-content",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("img", {
                  attrs: { src: _vm.selectedImage, alt: "Large Image" },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close-button",
                    on: { click: _vm.closeModal },
                  },
                  [_vm._v("X")]
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }